import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "trumbowyg/dist/ui/trumbowyg.css";
import iconsSvgPath from "trumbowyg/dist/ui/icons.svg";
import "trumbowyg/dist/plugins/table/ui/trumbowyg.table.css";
import "trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css";
import "./RichTextEditor.scss";

// Set jQuery globally for Trumbowyg
window.jQuery = $;
window.$ = $;

// Now require Trumbowyg and plugins after jQuery is globally available
require("trumbowyg");
require("trumbowyg/dist/plugins/table/trumbowyg.table.js");
require("trumbowyg/dist/plugins/colors/trumbowyg.colors.js");

const RichTextEditor = React.forwardRef(({ value, onChange, readOnly = false }, ref) => {
  const containerRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!containerRef.current || isInitialized.current) return;

    const $editor = $(containerRef.current);

    // Initialize Trumbowyg with plugins
    $editor.trumbowyg({
      btns: [
        ["bold", "italic", "underline"],
        ["unorderedList", "orderedList"], 
        ["link"],
        ["foreColor"],
        ["table"],
      ],
      semantic: true,
      autogrow: false,
      disabled: readOnly,
      svgPath: iconsSvgPath,
    });

    // Set initial value
    if (value) {
      $editor.trumbowyg("html", value);
    }

    // Handle change events
    const handleChange = () => {
      const content = $editor.trumbowyg("html");
      onChange(content);
    };

    $editor.on("tbwchange", handleChange);
    isInitialized.current = true;

    return () => {
      $editor.off("tbwchange", handleChange);
      if ($editor.data("trumbowyg")) {
        $editor.trumbowyg("destroy");
        isInitialized.current = false;
      }
    };
  }, [onChange, readOnly]);

  // Update content when value prop changes
  useEffect(() => {
    if (!containerRef.current || !isInitialized.current) return;

    const $editor = $(containerRef.current);
    const currentContent = $editor.trumbowyg("html");
    const normalizedValue = value || "";

    if (currentContent !== normalizedValue) {
      $editor.trumbowyg("html", normalizedValue);
    }
  }, [value]);

  return (
    <div className="rich-text-editor" ref={containerRef}>
    </div>
  );
});

RichTextEditor.displayName = "RichTextEditor";

export default RichTextEditor;
